import { getAddressAb } from '@/hooks/abTest/useAddressAb';
import queryString from 'query-string';

export async function parseWebpack(url: string) {
    const ab = await getAddressAb();
    const ifEnterKrnWebpack = ab?.find((item) => item.key === 'if_krn_webpack')?.value;
    if (!ifEnterKrnWebpack) return url;

    const parseUrl = queryString.parseUrl(url);
    let redirectUrl = parseUrl.query.redirectUrl;
    if (!redirectUrl) return url;

    const redirectUrlObj = queryString.parse(redirectUrl as string);
    const bundleId = redirectUrlObj.bundleId as string;
    const componentName = redirectUrlObj.componentName as string;
    if (['Detail', 'EcommMerchant', 'MyShoppingCar', 'EcommOrderConfirm'].includes(bundleId)) {
        redirectUrlObj.bundleId = `Exp${bundleId}`;
        redirectUrlObj.componentName = `Exp${componentName}`;
    }
    redirectUrl = queryString.stringify(redirectUrlObj);
    return queryString.stringifyUrl({
        url,
        query: {
            redirectUrl,
        },
    });
}
